<template>
    <div class="cell-content" :class="(cell && cell._meta && cell._meta.additionalCSSClasses) ? cell._meta.additionalCSSClasses : []" @click.prevent="onClick">
        <div v-if="type == 'string'">{{ cellValue }} <i v-if="(cell && cell._meta && cell._meta.hasWarningTriangle)" class="fas fa-fw fa-exclamation-triangle"></i><i v-if="(cell && cell._meta && cell._meta.hasCheckmark)" class="fas fa-fw fa-check-circle"></i></div>

        <div v-if="type == 'date' && cell">{{ $filters.date(cellValue, header.format) }}</div>
        <div v-if="type == 'datetime' && cell">{{ $filters.datetimeshort(cellValue, header.format) }}</div>
        <div v-if="['date', 'datetime'].includes(type) && !cell">---</div>
        <div v-if="type == 'relative-date' && cell">{{ $filters.fromNow(cellValue) }}</div>

        <div v-if="type == 'money' && cell">${{ cellValue }}</div>
        <div v-if="type == 'money' && !cell">---</div>

        <progress-bar v-if="type == 'progress' && cell !== ''" :progress="cellValue" />

        <i v-if="type == 'checkmark' && cellValue" class="text-muted fas fa-fw fa-check" aria-label="Yes"></i>

        <div v-if="type == 'copy' && cellValue">
            <a class="mr-hf" href @click.prevent.stop="$bus.copyToClipboard(cellValue)">
                <i class="far fa-copy text-primary" aria-label="Copy" title="Copy"></i>
            </a>
            <span>{{ cellValue }}</span>
        </div>

        <div class="counter counter-warnings" v-if="type == 'warning' && cellValue && !isNaN(parseInt(cellValue, 10))" >
            <i class="counter-icon fas fa-fw fa-exclamation-triangle" aria-label="Warnings"></i>
            <span class="counter-label">{{ cellValue }}</span>
        </div>

        <div class="counter counter-errors" v-if="type == 'warning' && cellValue == 'error'" >
            <i class="counter-icon fas fa-fw fa-exclamation-circle" aria-label="Error"></i>
        </div>

        <div class="counter text-500" v-if="type == 'warning' && cellValue == 'scarlet-letter'" >
            <i class="counter-icon fas fa-fw fa-exclamation-triangle" aria-label="I-9 Completed Late"></i>
        </div>

        <div v-if="type == 'checkmark-or-warning' && cellValue">
            <div v-if="cellValue == 'OK'">
                <i class="text-muted fas fa-fw fa-check" aria-label="Yes"></i>
            </div>
            <div v-else>
                <i class="counter-icon fas fa-fw fa-exclamation-triangle" :aria-label="cellValue"></i>
            </div>
        </div>

        <div v-if="type == 'checkmark-or-blank' && cellValue">
            <div v-if="cellValue == 'OK'">
                <i class="text-muted fas fa-fw fa-check" aria-label="Yes"></i>
            </div>
            <div v-else>

            </div>
        </div>

        <a :href="cell.url" class="d-print-none" v-if="type == 'link'" @click.prevent="open(cell.url)">
            <i class="far fa-fw fa-file-pdf mr-hf"></i>
            <span>{{ cell.label }}</span>
        </a>

        <a href class="d-print-none" v-if="type == 'action'" @click.prevent.stop="cell.callback(cell.callbackValue)">
            <span v-if="cell.label">{{ cell.label }}</span>
            <span v-if="cell.html" v-html="cell.html"></span>
        </a>

        <span v-if="type == 'router-link'">
            <router-link :to="cell.route">{{ cell.label }}</router-link>
        </span>

        <cell-input v-if="isInputType" class="grid-input" :type="type" @blur="onBlur" @input="onInput" :value="cellValue" :disabled="disabled" :show-zero="showZero"/>
    </div>
</template>

<script>
import ProgressBar from '@/components/ProgressBar'
import CellInput from './CellInput'

export default {
    props: ['cell', 'header', 'inputDisabled'],
    components: {ProgressBar, CellInput},
    emits: ['click', 'blur'],
    computed: {
        type() {
            if (this.cell?._meta?.type) {
                return this.cell._meta.type
            }

            return this.header.type || 'string'
        },
        cellValue() {
            if (this.cell?._meta) {
                return this.cell.value
            }
            return this.cell
        },
        isInputType() {
            return ['currency-input', 'decimal-input'].includes(this.type)
        },
        disabled() {
            if (this.inputDisabled) {
                return true
            }
            return this.cell?._meta?.disabled || false
        },
        showZero() {
            return this.cell?._meta?.showZero || false
        },
    },
    methods: {
        open(url) {
            window.open(url)
        },
        onClick($event) {
            this.$emit('click', $event)
        },
        onInput($event) {
            // currently only onBlur is necessary so this is a dead-end for the event but could be plumbed through to the top level if necessary
        },
        onBlur($event) {
            let msg = {
                value: $event,
            }
            if (this.cell?._meta) {
                msg.field = this.cell._meta.field
                msg.cell_meta = this.cell._meta
            }
            this.$emit('blur', msg)
        },
    },
}
</script>
